import React from "react";
import "../../../css/View/SummaryFood.css";

const SummaryFood = ({ registrations }) => {
  const people = (registrations || []).flatMap((r) => {
    const activeParticipants = (r.participants || []).filter(
      (p) => p.status !== 4 && p.status !== 5
    );
    const primary = activeParticipants.find((p) => p.isPrimary);
    if (!primary) return [];

    return [
      {
        ...primary,
        reservationCode: r.reservationCode,
        participantCount: !r.createdAt ? (r.pax || 0) : activeParticipants.length,
        reservationStatus: r.status,
        foodInfo: r.additionalInfo?.foodInfo,
      },
    ];
  });

  const renderValue = (v) => (v && String(v).trim() ? v : "-");

  return (
    <div className="summary-food-container">
      <h3>Wyżywienie</h3>

      <div className="table-scroll-container">
        <table className="summary-food-table">
          <thead>
            <tr>
              <th>Rezerwacja</th>
              <th>Informacje o diecie</th>
            </tr>
          </thead>
          <tbody>
            {people.map((p, idx) => (
              <tr key={`${p.reservationCode}-${idx}`}>
                <td>
                  <div>
                    <span className={`reg-code status-${p.reservationStatus}`}>
                      {p.reservationCode}
                    </span>{" "}
                    <span className="reservation-count">
                      ({p.participantCount} x <i className="fas fa-user"></i>)
                    </span>
                  </div>
                  <div className="participant-name">{p.preferredName}</div>
                </td>

                <td>{renderValue(p.foodInfo)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SummaryFood;
